let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3nxLJ")).then(() => parcelRequire('blD8v'));